import React, { Fragment } from 'react';
import { ActionTableBodyItem, TableBodyItem, TableItemImage } from '../../Table.styles';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons/chevron_right.svg';
import { useLocation } from 'react-router-dom';
import { CHATTER_MESSAGES, CHATTER_VAULT } from '../../../App/routes';
import { Link } from './ChatterInfluencerItem.styles';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/slices/user/slice';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../../utils/constants';

const ChatterInfluencerItem = ({ id, profilePhoto, name, unreadCount }) => {
  return (
    <Fragment>
      <TableBodyItem>
        <TableBodyItemLinkWrapper id={id}>
          <TableItemImage src={profilePhoto} alt="influencer-profile" />
          <p>{name || '-'}</p>
        </TableBodyItemLinkWrapper>
      </TableBodyItem>

      {unreadCount > 0 && (
        <TableBodyItem>
          <TableBodyItemLinkWrapper id={id}>
            {unreadCount === 1 && ( <p>1 unread message</p>)}
            {unreadCount > 1 && ( <p>{unreadCount} unread messages</p>)}
           
          </TableBodyItemLinkWrapper>
        </TableBodyItem>
      )}
      <ActionTableBodyItem>
        <TableBodyItemLinkWrapper id={id}>
          <ArrowIcon width={24} height={24} color="#1672BA" />
        </TableBodyItemLinkWrapper>
      </ActionTableBodyItem>
    </Fragment>
  );
};

const TableBodyItemLinkWrapper = ({ id, children }) => {
  const location = useLocation();
  const user = useSelector(selectUser);
  const link =
    user.role === CRM_ORGANIZATION_MEMBER_ROLE.CONTENT_MANAGER
      ? `/${CHATTER_VAULT.replace(':influencerId', id)}`
      : `/${CHATTER_MESSAGES.replace(':influencerId', id)}`;
  return (
    <Link to={link} state={{ from: location }}>
      {children}
    </Link>
  );
};

export default ChatterInfluencerItem;
